import {
  GET_MAINTENANCE_RECORDS_REQUEST,
  GET_MAINTENANCE_RECORDS_SUCCESS,
  GET_MAINTENANCE_RECORDS_ERROR,
  GET_MAINTENANCE_RECORD_REQUEST,
  GET_MAINTENANCE_RECORD_SUCCESS,
  GET_MAINTENANCE_RECORD_ERROR,
  GET_REPAIR_DETAILS_REQUEST,
  GET_REPAIR_DETAILS_SUCCESS,
  GET_REPAIR_DETAILS_ERROR,
  CREATE_REPAIR_RECORD_REQUEST,
  CREATE_REPAIR_RECORD_SUCCESS,
  CREATE_REPAIR_RECORD_ERROR,
  CREATE_MAINTENANCE_RECORD_REQUEST,
  CREATE_MAINTENANCE_RECORD_SUCCESS,
  CREATE_MAINTENANCE_RECORD_ERROR,
  UPDATE_MAINTENANCE_RECORD_REQUEST,
  UPDATE_MAINTENANCE_RECORD_SUCCESS,
  UPDATE_MAINTENANCE_RECORD_ERROR,
  DELETE_REPAIR_RECORD_REQUEST,
  DELETE_REPAIR_RECORD_SUCCESS,
  DELETE_REPAIR_RECORD_ERROR,
} from './maintenanceActionTypes';

const initialState = {
  isLoading: false,
  isSaving: false,
  isSuccess: false,
  message: '',
  maintenanceRecords: [],
  maintenanceRecord: {},
  maintenanceRepairs: [],
  maintenanceStatistics: {},
  pagination: {},
  itemsCount: 0,
};

/**
 * Every branch spreads `state`.
 *
 * These cases used to return only the handful of flags the action carried, so a
 * write — or even a plain REQUEST — blanked `maintenanceRecord`,
 * `maintenanceRepairs` and `maintenanceRecords`. That is why the components had
 * to guard every read with `?.` and refetch on a 2s timer to get their data back.
 */
export default function maintenanceReducer(state = initialState, action) {
  const { type, payload, isLoading, isSuccess, message } = action;

  switch (type) {
    // ----- maintenance list -------------------------------------------------
    case GET_MAINTENANCE_RECORDS_REQUEST:
      return { ...state, isLoading, message: '' };
    case GET_MAINTENANCE_RECORDS_SUCCESS:
      return {
        ...state,
        isLoading,
        maintenanceRecords: payload.data ?? [],
        maintenanceStatistics: payload.statistics ?? {},
        pagination: payload,
      };
    case GET_MAINTENANCE_RECORDS_ERROR:
      return { ...state, isLoading, message };

    // ----- single record ----------------------------------------------------
    case GET_MAINTENANCE_RECORD_REQUEST:
      return { ...state, isLoading, message: '' };
    case GET_MAINTENANCE_RECORD_SUCCESS:
      return { ...state, isLoading, maintenanceRecord: payload.data ?? {} };
    case GET_MAINTENANCE_RECORD_ERROR:
      return { ...state, isLoading, message };

    // ----- repair lines -----------------------------------------------------
    case GET_REPAIR_DETAILS_REQUEST:
      return { ...state, isLoading, isSuccess, message: '' };
    case GET_REPAIR_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading,
        isSuccess,
        maintenanceRepairs: payload.data ?? [],
        itemsCount: payload.count ?? 0,
      };
    case GET_REPAIR_DETAILS_ERROR:
      return { ...state, isLoading, isSuccess, message };

    // ----- writes -----------------------------------------------------------
    // `isSaving` is kept apart from `isLoading` so submitting a dialog does not
    // swap the table behind it for a spinner.
    case CREATE_MAINTENANCE_RECORD_REQUEST:
    case CREATE_REPAIR_RECORD_REQUEST:
    case UPDATE_MAINTENANCE_RECORD_REQUEST:
    case DELETE_REPAIR_RECORD_REQUEST:
      return { ...state, isSaving: true, isSuccess: false, message: '' };

    case CREATE_MAINTENANCE_RECORD_SUCCESS:
    case CREATE_REPAIR_RECORD_SUCCESS:
    case UPDATE_MAINTENANCE_RECORD_SUCCESS:
    case DELETE_REPAIR_RECORD_SUCCESS:
      return { ...state, isSaving: false, isSuccess: true, message };

    case CREATE_MAINTENANCE_RECORD_ERROR:
    case CREATE_REPAIR_RECORD_ERROR:
    case UPDATE_MAINTENANCE_RECORD_ERROR:
    case DELETE_REPAIR_RECORD_ERROR:
      return { ...state, isSaving: false, isSuccess: false, message };

    default:
      return state;
  }
}
